import * as constants from '../constants';

import { LandingPagesAction } from '../actions/landingPages';
import * as types from '../types';
import { Venues } from '@weddingspot/ws-api-client';

const getDefaultState = () => ({
    name: '',
    url_subpath: '',
    market: '',
    region: '',
    hero_image_1_url: '',
    hero_image_1_credit: '',
    hero_image_1_link: '',
    hero_image_2_credit: '',
    hero_image_2_link: '',
    hero_image_2_url: '',
    title_1: '',
    title_2: '',
    description_1: '',
    description_2: '',
    google_map_settings: '',
    description_3: '',
    published: false,
    cta_url_1: '',
    carousel_venue_ids: '',
    recommendedVenues: [],
    meta_title_override: '',
    market_venue_count: 0,
    isLoaded: false,
});

export function landingPages(state: types.LandingPageState = getDefaultState(), action: LandingPagesAction) {
    switch (action.type) {
        case constants.LOAD_LANDING_PAGE_DATA:
            return { ...getDefaultState(), ...action.payload };
        case constants.LOAD_LANDING_PAGE_RECOMMENDED_VENUES:
            return {
                ...state,
                recommendedVenues: action.payload.filter((v) => v.is_not_available === undefined) as Venues.VenueDetails[],
            };
        case constants.LANDING_PAGE_LOADED:
            return { ...state, isLoaded: true };
        default:
            return state;
    }
}

export default landingPages;
